import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type CurrentTimeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentTimeQuery = { __typename?: 'Query', Users: { __typename?: 'UserQueries', currentTime: { __typename?: 'CurrentTime', ts: number } } };

export type AccountSetupStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AccountSetupStatusQuery = { __typename?: 'Query', Users: { __typename?: 'UserQueries', accountSetupStatus: { __typename?: 'AccountSetupStatus', fronteggLegacyUserId?: string | null, fronteggLinked?: boolean | null, ogUserAuthId?: string | null, profileFirstName?: string | null, profileLastName?: string | null, profileDisplayName?: string | null, tenantId?: string | null, personalRoomId?: string | null, personalRoomSlugPath?: string | null } } };

export type LinkUserMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LinkUserMutation = { __typename?: 'Mutation', linkUser: { __typename?: 'LinkedUser', userId: string, email: string, legacyUserId?: string | null, linked?: boolean | null, hasUserProfile: boolean } };

export type CreateUserProfileMutationVariables = Types.Exact<{
  input: Types.CreateUserProfileInput;
}>;


export type CreateUserProfileMutation = { __typename?: 'Mutation', createUserProfile: { __typename?: 'CreateUserProfileResponse', legacyUserId: string } };

export type UpdateUserProfileMutationVariables = Types.Exact<{
  input: Types.UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: boolean };

export type DeleteUserMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type SyncUserEmailUpdateMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SyncUserEmailUpdateMutation = { __typename?: 'Mutation', syncUserEmailUpdate: boolean };

export type VerifyUserMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type VerifyUserMutation = { __typename?: 'Mutation', verifyUser: boolean };

export type GetTenantUsersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantUsersQuery = { __typename?: 'Query', Users: { __typename?: 'UserQueries', tenantUsers: Array<{ __typename?: 'TenantUser', id: string, name: string, email: string, profilePictureUrl: string, lastLogin?: string | null, roomMembershipCount: number, tenants: Array<{ __typename?: 'TenantUserTenant', tenantId: string, isDisabled?: boolean | null }> }> } };

export type CannyTokenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CannyTokenQuery = { __typename?: 'Query', Users: { __typename?: 'UserQueries', cannyToken: { __typename?: 'CannyToken', token: string, userHash: string } } };

export type GetTenantUsersWithRolesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantUsersWithRolesQuery = { __typename?: 'Query', Users: { __typename?: 'UserQueries', tenantUsers: Array<{ __typename?: 'TenantUser', id: string, name: string, email: string, profilePictureUrl: string, lastLogin?: string | null, tenants: Array<{ __typename?: 'TenantUserTenant', tenantId: string, isDisabled?: boolean | null, roles: Array<{ __typename?: 'TenantUserRole', id: string, key: string, name: string, level: number }> }> }> } };


export const CurrentTimeDocument = `
    query CurrentTime {
  Users {
    currentTime {
      ts
    }
  }
}
    `;
export const AccountSetupStatusDocument = `
    query AccountSetupStatus {
  Users {
    accountSetupStatus {
      fronteggLegacyUserId
      fronteggLinked
      ogUserAuthId
      profileFirstName
      profileLastName
      profileDisplayName
      tenantId
      personalRoomId
      personalRoomSlugPath
    }
  }
}
    `;
export const LinkUserDocument = `
    mutation LinkUser {
  linkUser {
    userId
    email
    legacyUserId
    linked
    hasUserProfile
  }
}
    `;
export const CreateUserProfileDocument = `
    mutation CreateUserProfile($input: CreateUserProfileInput!) {
  createUserProfile(input: $input) {
    legacyUserId
  }
}
    `;
export const UpdateUserProfileDocument = `
    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input)
}
    `;
export const DeleteUserDocument = `
    mutation DeleteUser {
  deleteUser
}
    `;
export const SyncUserEmailUpdateDocument = `
    mutation SyncUserEmailUpdate {
  syncUserEmailUpdate
}
    `;
export const VerifyUserDocument = `
    mutation VerifyUser {
  verifyUser
}
    `;
export const GetTenantUsersDocument = `
    query GetTenantUsers {
  Users {
    tenantUsers {
      id
      name
      email
      profilePictureUrl
      lastLogin
      roomMembershipCount
      tenants {
        tenantId
        isDisabled
      }
    }
  }
}
    `;
export const CannyTokenDocument = `
    query CannyToken {
  Users {
    cannyToken {
      token
      userHash
    }
  }
}
    `;
export const GetTenantUsersWithRolesDocument = `
    query GetTenantUsersWithRoles {
  Users {
    tenantUsers {
      id
      name
      email
      profilePictureUrl
      lastLogin
      tenants {
        tenantId
        isDisabled
        roles {
          id
          key
          name
          level
        }
      }
    }
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    CurrentTime: build.query<CurrentTimeQuery, CurrentTimeQueryVariables | void>({
      query: (variables) => ({ document: CurrentTimeDocument, variables })
    }),
    AccountSetupStatus: build.query<AccountSetupStatusQuery, AccountSetupStatusQueryVariables | void>({
      query: (variables) => ({ document: AccountSetupStatusDocument, variables })
    }),
    LinkUser: build.mutation<LinkUserMutation, LinkUserMutationVariables | void>({
      query: (variables) => ({ document: LinkUserDocument, variables })
    }),
    CreateUserProfile: build.mutation<CreateUserProfileMutation, CreateUserProfileMutationVariables>({
      query: (variables) => ({ document: CreateUserProfileDocument, variables })
    }),
    UpdateUserProfile: build.mutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>({
      query: (variables) => ({ document: UpdateUserProfileDocument, variables })
    }),
    DeleteUser: build.mutation<DeleteUserMutation, DeleteUserMutationVariables | void>({
      query: (variables) => ({ document: DeleteUserDocument, variables })
    }),
    SyncUserEmailUpdate: build.mutation<SyncUserEmailUpdateMutation, SyncUserEmailUpdateMutationVariables | void>({
      query: (variables) => ({ document: SyncUserEmailUpdateDocument, variables })
    }),
    VerifyUser: build.mutation<VerifyUserMutation, VerifyUserMutationVariables | void>({
      query: (variables) => ({ document: VerifyUserDocument, variables })
    }),
    GetTenantUsers: build.query<GetTenantUsersQuery, GetTenantUsersQueryVariables | void>({
      query: (variables) => ({ document: GetTenantUsersDocument, variables })
    }),
    CannyToken: build.query<CannyTokenQuery, CannyTokenQueryVariables | void>({
      query: (variables) => ({ document: CannyTokenDocument, variables })
    }),
    GetTenantUsersWithRoles: build.query<GetTenantUsersWithRolesQuery, GetTenantUsersWithRolesQueryVariables | void>({
      query: (variables) => ({ document: GetTenantUsersWithRolesDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCurrentTimeQuery, useLazyCurrentTimeQuery, useAccountSetupStatusQuery, useLazyAccountSetupStatusQuery, useLinkUserMutation, useCreateUserProfileMutation, useUpdateUserProfileMutation, useDeleteUserMutation, useSyncUserEmailUpdateMutation, useVerifyUserMutation, useGetTenantUsersQuery, useLazyGetTenantUsersQuery, useCannyTokenQuery, useLazyCannyTokenQuery, useGetTenantUsersWithRolesQuery, useLazyGetTenantUsersWithRolesQuery } = injectedRtkApi;

